<template>
  <v-dialog
    v-model="dialog"
    persistent
    no-click-animation
    transition="dialog-bottom-transition"
    max-width="500"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn :color="color" fab small dark class="mx-2" v-bind="attrs" v-on="on">
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <AtomDialogForm
      :editWebsiteType="editWebsiteType || null"
      :toolbarColor="color"
      :dialog="dialog"
      v-if="dialog"
      @dialog="(data) => (dialog = data)"
      @websiteType="(data) => (websiteType = data)"
      @submit="submitForm"
    />
  </v-dialog>
</template>

<script lang="ts">
import AtomDialogForm from '../atoms/AtomDialogForm.vue'
import { defineComponent } from 'vue'
import { WebsiteType } from '@/store/models/website-type'
import { mapActions, mapGetters } from 'vuex'
import { toSnakeCase } from '@/utils/string-manipulation'
import { saveMessage } from '@/utils/constants'

export default defineComponent({
  props: {
    icon: {
      type: String,
      default: 'mdi-plus'
    },
    color: {
      type: String,
      default: 'primary'
    },
    editWebsiteType: {
      type: Object as () => WebsiteType | null
    }
  },
  components: {
    AtomDialogForm
  },
  data () {
    return {
      dialog: false,
      websiteType: {} as WebsiteType
    }
  },
  computed: {
    ...mapGetters({
      getPagination: 'websiteType/getPagination'
    })
  },
  methods: {
    ...mapActions({
      setTableLoading: 'global/setTableLoading',
      setPageLoading: 'global/setPageLoading',
      fetchWebsiteTypes: 'websiteType/fetchWebsiteTypes',
      saveWebsiteType: 'websiteType/saveWebsiteType'
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    appendFormData (data: WebsiteType): Record<string, any> {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const formData: Record<string, any> = {}
      for (const [key, value] of Object.entries(data)) {
        const snakeCaseKey = toSnakeCase(key)
        formData[snakeCaseKey] = value
      }
      return formData
    },
    submitForm (): void {
      const formData = this.appendFormData(this.websiteType)

      if (confirm(saveMessage) === true) {
        this.setPageLoading(true)
        this.saveWebsiteType(formData)
          .then(() => {
            this.dialog = false
            this.setTableLoading(true)
            this.fetchWebsiteTypes(this.getPagination).finally(() => {
              this.setTableLoading(false)
            })
          })
          .catch((error) => {
            if (error.response && error.response.data && error.response.data.errors) {
              const errorMessages = Object.values(error.response.data.errors).flat()
              const errorMessage = errorMessages.join('<br/>')
              this.$message({
                dangerouslyUseHTMLString: true,
                message: errorMessage,
                type: 'error'
              })
            } else {
              console.error('An error occurred:', error)
            }
          })
          .finally(() => {
            this.setPageLoading(false)
          })
      }
    }
  }
})
</script>
